import User from './things/User' ;

const user = new User() ;

export default user ;


// WEBPACK FOOTER //
// ./src/app/user.js